// extracted by mini-css-extract-plugin
export default {"link":"tK-z","disabled":"uK-z"};